import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import $ from 'jquery';
import classnames from 'classnames';

const GLOBAL = require('../../Globals');

class EditSubjectAllocation extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			depart : '',
			employ : '',
			cls : '',
			section : '',
			subject : '',
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			secs : [],
			accyear : [],
			subj : [],
			dep : [],
			emp : [],
			activeTab: '1'
		}
		this.onChange = this.onChange.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** reset caste form **/
	onClick(e){
		
		document.getElementById("casform").reset();
	}
	
	/** reset religion form **/
	relClick(e){
		
		document.getElementById("relform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	/** submit caste form **/
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.acyear && this.state.depart && this.state.employ && this.state.cls && this.state.section && this.state.subject){
			
			PostData('subjectallocation/update',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Subject Allocation Updated Successfully!..',
						alertClass:'alert alert-success'
					});
					document.getElementById("suballform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});	
		}
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		this.getclass();
		this.getsection();
		this.getsubject();
		this.getdepartment();
		this.getemployee();
		this.getdetails();
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					dep : responseJson
				});
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		
		GetData('employee/getteacher').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					emp : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Section **/
	getsection(){
		
		GetData('section/getsection').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					secs : responseJson
				});
			}
		});
	}
	
	/** get Subject **/
	getsubject(){
		
		GetData('subject/getsub').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					subj : responseJson
				});
			}
		});
	}
	
	/** get Details by id **/
	getdetails(){
		
		GetData('subjectallocation/getdetailsbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					acyear : res[0]['acyear'],
					depart : res[0]['department'],
					employ : res[0]['employee'],
					cls : res[0]['class'],
					section : res[0]['section'],
					subject : res[0]['subject']
				});
			}
		});
	}
	
	
  render() {
	
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/caste' />);
	}
	
	  var acyear = this.state.accyear;
	  var items = this.state.posts;
	  var sec = this.state.secs;
	  var sub = this.state.subj;
	  var dept = this.state.dep;
	  var empl = this.state.emp;
  
   /** get Employee By Department **/
	$("#deprt").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'employee/getempbydept/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#empl").html('');
			$('#empl')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Employee- ')); 
			$.each(o,function(key,value){			
				   $('#empl')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.empname)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		var ar = $("#year").val();
		$.get(GLOBAL.BASE_URL+'section/getsecbyclass/'+ar+'/'+fr,function(o){
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});	
			
		},'json');
	
	});
  
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
        <Row>
          <Col md="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                  Subject Allocation
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  Report
                </NavLink>
              </NavItem>
			  <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '3' })}
                  onClick={() => { this.toggle('3'); }}
                >
                  Manage
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
				<Row>
				<Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="suballform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Subject Allocation</strong>
					</CardHeader>
					<CardBody>
					  <Row>
					    <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Academic Year <span className="text-danger">*</span></Label>
							  <select name="acyear" className="form-control" onChange={this.onChange} required id="year" value={this.state.acyear}>
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Department <span className="text-danger">*</span></Label>
							  <select name="depart" onChange={this.onChange} className="form-control" id="deprt" required value={this.state.depart}> 
								<option value="">Select Department</option>
								{
									dept.map(function (item) {
										return <option value={item.id }>{item.department}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Employee Name <span className="text-danger">*</span></Label>
							  <select name="employ" onChange={this.onChange} className="form-control" id="empl" required value={this.state.employ} > 
								<option value="">Select Employee</option>
								{
									empl.map(function (item) {
										return <option value={item.id }>{item.empname}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <select name="cls" onChange={this.onChange} className="form-control" id="clas" required value={this.state.cls}> 
								<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <select name="section" onChange={this.onChange} className="form-control" id="secs" required value={this.state.section} >
								<option value="">Select Section</option>
								{
									sec.map(function (item) {
										return <option value={item.id }>{item.section}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
							 <select name="subject" onChange={this.onChange} className="form-control" required value={this.state.subject} > 
								<option value="">Select Subject</option>
								{
									sub.map(function (item) {
										return <option value={item.id }>{item.subject}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
				</Col>
				<Col md="7">
					
				</Col>
				</Row>
			  </TabPane>
			  <TabPane tabId="2">
				<Row>
				<Col md="6">
				
				</Col>
				<Col md="6">
					
				</Col>
				</Row>
			  </TabPane>
			  <TabPane tabId="3">
			  
			  </TabPane>
			</TabContent>
		  </Col>
		</Row>
		</div>
	);
  }
}

export default EditSubjectAllocation;


// WEBPACK FOOTER //
// ./src/subject/SubjectAllocation/EditSubjectAllocation.js